export default __webpack_public_path__ + "static/media/im-title-en.66fcf6d3.webp";